import { FETCH_PARTICIPANTS, FETCH_PARTICIPANTS_SUCCESS, FETCH_PARTICIPANTS_FAILURE } from '../actions';

const initialState = {
  participants: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_PARTICIPANTS:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        participants: action.data
      };
    case FETCH_PARTICIPANTS_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        participants: []
      };
    default:
      return state;
  }
}